<div class="p-6 h-full flex flex-col">
	@if (data?.properties?.length > 0) {
		<div class="mb-4 h-auto">
			@for (item of data?.properties; track $index) {
				<div class="flex gap-4 items-center mb-4">
					<div class="font-semibold">{{ item?.property }}</div>
					<div>{{ item?.value }}</div>
				</div>
			}
		</div>
	}

	@if (data?.url) {
		<app-pdftron [url]="data?.url" #pdfViewer class="w-full h-full" />
	}
</div>
